import React, {useContext} from 'react';
import {Maybe} from 'monet';
import * as R from 'ramda';
import {Row, Col} from 'reactstrap';
import {useFixedTranslation} from '@/i18n';
import Select from '@/Form/Select';
import Icon from '@/views/shared/Icon';
import DownloadFileButton from '@/views/shared/DownloadFileButton';

import {PolicyStatementCtx} from '@/b2b/contexts';

const SelectPolicy = () => {
  const [state, dispatch] = useContext(PolicyStatementCtx);
  const {partyId, policyList, statementLanguage} = state;

  const tr = useFixedTranslation(statementLanguage, 'statement');
  const buildPolicyListSelectOptions = R.map(([id, info]) => (
    <option value={id} key={id}>
      {info.accountNo}
    </option>
  ))(R.toPairs(policyList));

  const onChangePolicy = e => {
    const nextPartyId = e.currentTarget.value;
    dispatch({type: 'changePolicy', payload: {nextPartyId}});
  };

  const partyIds = R.compose(
    R.join(','),
    R.keys,
    R.filter(item => item.accountType !== 'CONSOLIDATE')
  )(policyList);

  const zipPath = `/statement/download_zip?party_ids=${partyIds}`;
  const pdfPath = `/statement/download_pdf?party_ids=${partyIds}`;

  const Content = () => (
    <Row className='d-flex justify-content-end mt-0'>
      <Col md='auto' className='pr-1 pt-2'>
        {tr('other_policies')}
      </Col>
      <Col md={3} className='pl-1 pt-1'>
        <Select name='partyId' onChange={onChangePolicy} value={partyId}>
          {buildPolicyListSelectOptions}
        </Select>
      </Col>
      <Col md='auto' className='pl-1 pt-1'>
        <DownloadFileButton className='btn btn-link btn-lg px-0' path={pdfPath}>
          <Icon icon='file-pdf' />{' '}
        </DownloadFileButton>
        <DownloadFileButton
          className='btn btn-link btn-lg pl-3"'
          path={zipPath}
        >
          <Icon icon='file-archive' />{' '}
        </DownloadFileButton>
      </Col>
    </Row>
  );

  return Maybe.fromFalsy(Object.keys(policyList).length > 1)
    .map(() => <Content />)
    .orNull();
};

export default SelectPolicy;
